import classNames from "classnames";
import React from "react";

import { InputGroupText } from "./inputGroupText.component";

export type InputGroupAddonComponentProps = {
    addonType: "prepend" | "append";
};

export type InputGroupAddonProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, InputGroupAddonComponentProps, "div">;

const InputGroupAddon = <T extends React.ElementType = "div">({
    addonType,
    children,
    className,
    tag,
    ...attributes
}: InputGroupAddonProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = classNames(className, "input-group-" + addonType);

    if (typeof children === "string") {
        return (
            <Tag {...attributes} className={classes}>
                <InputGroupText>{children}</InputGroupText>
            </Tag>
        );
    }
    return (
        <Tag {...attributes} className={classes}>
            {children}
        </Tag>
    );
};

export { InputGroupAddon };
